import { useEffect, useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { setAccessToken, setTokenRefresher } from "./apiClient";

/**
 * Invisible component that keeps the Axios API client in sync with the
 * current OIDC access token and provides a refresh callback for 401 retries.
 * Mount it inside the <AuthProvider> tree.
 */
export function ApiTokenSync() {
  const auth = useAuth();

  // Keep the token in sync whenever oidc-client-ts renews it
  useEffect(() => {
    setAccessToken(auth.user?.access_token ?? null);
  }, [auth.user?.access_token]);

  // Provide a way for the axios interceptor to request a fresh token on 401
  const refreshToken = useCallback(async (): Promise<string | null> => {
    const user = await auth.signinSilent();
    return user?.access_token ?? null;
  }, [auth]);

  useEffect(() => {
    setTokenRefresher(refreshToken);
    return () => setTokenRefresher(null);
  }, [refreshToken]);

  return null;
}
